export default (reducer) =>
  (state = [], action) => {
    let isChanged = false;

    const nextState = state.map((arrayItem) => {
      const nextArrayItem = reducer(arrayItem, action);

      isChanged = isChanged || nextArrayItem !== arrayItem;

      return nextArrayItem;
    });

    return isChanged ? nextState : state;
  };
